import Abstract from "@homer.core/storage";

const storage = (function () {
    try {
        return "localStorage" in globalThis && globalThis.localStorage.getItem && globalThis.localStorage;
    } catch (_) {}

    return false;
})();

class Storage extends Abstract {
    constructor(identifier, options = {}) {
        super(identifier, storage, options);
    }

    static supported = !!storage;
}

export default Storage;
